module.exports = __webpack_public_path__ + "img/programme4.b8915fcc.png";